export default "__VITE_ASSET__Clpr9gB3__"